import { debounce } from 'lodash';

export function notUndefined<T>(x: T | undefined): x is T {
  return x !== undefined;
}

export function generateUniqueId() {
  return Math.floor(Math.random() * Date.now());
}

export const debounceEventIfNotTrusted = ({
  cb,
  isTrusted,
  debounceDuration = 500,
}: {
  cb: <T>() => T | void;
  isTrusted?: boolean;
  debounceDuration?: number;
}) => {
  // due to scripting, a browser event might not be trusted as it can originate from a script or other non trusted sources. This prevents the event from being fired multiple times
  if (isTrusted !== undefined && isTrusted) {
    cb();
  } else {
    debounce(cb, debounceDuration);
  }
};

export const awaitTimeout = async (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
